import React, { useEffect, useState } from 'react'
import ConfigSideNav from './ConfigSideNav'
import { Grid, InputAdornment, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, TextField } from '@material-ui/core'
import { globalGetService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';
import CurrenciesList from './CurrenciesList';
import { STableLoader } from '../../shared_elements';
import CloseIcon from '@material-ui/icons/Close';

const CurrenciesHd = ({ createSortHandler, sortInfo, }) => {

  const tableSorting = (key, name) => {
    return (
      <TableSortLabel
        active={sortInfo.sort === key ? true : false}
        direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
        onClick={() => createSortHandler(key)}
      >
        {name}
      </TableSortLabel>
    )
  }

  return (
    <TableHead>
      <TableRow >
        <TableCell sx={{ minWidth: '130px' }}> {tableSorting('name', 'Name')}</TableCell>
        <TableCell sx={{ minWidth: '130px' }}> {tableSorting('symbol', 'Symbol')}</TableCell>
        <TableCell sx={{ minWidth: '150px' }}> {tableSorting('symbol_native', 'Symbol Native')}</TableCell>
        <TableCell sx={{ minWidth: '150px' }}> {tableSorting('decimal_digits', 'Decimal Digits')}</TableCell>
        <TableCell sx={{ minWidth: '120px' }}> {tableSorting('rounding', 'Rounding')}</TableCell>
        <TableCell sx={{ minWidth: '130px' }}> {tableSorting('code', 'Code')}</TableCell>
        <TableCell sx={{ minWidth: '100px' }}> Enabled </TableCell>
      </TableRow>
    </TableHead>
  );
};

const CurrenciesIndex = () => {
  const [currenciesInfo, setCurrenciesInfo] = useState()
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getCurrencies({},"skeletonLoader")
  },[])

  const getCurrencies = (query = {},loaderType) => {
    loaderType === 'skeletonLoader' && setSkeletonLoader(true) 
     globalGetService('/console/global-currency/',query)
     .then(response => {
        if(checkApiStatus(response)){
          setCurrenciesInfo(response?.data?.data)
        }
        loaderType === 'skeletonLoader' && setSkeletonLoader(false) 
     })
  }

  const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
    getCurrencies({ ...sortQuery })
	}

  return (
    <section className="config-container">
      <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 82}px` }}>
        <ConfigSideNav />
        <div className="tech-specs-content">
          {skeletonLoader ? <STableLoader count={7} size={9}/> :
          <>
              <div className="console-forms-fields" style={{ marginBottom: "5px" }}>
                <Grid container>
                  <Grid item md={4}>
                    <TextField
                      id='lessee'
                      value={search}
                      fullWidth
                      placeholder='Search by Currency Name'
                      margin="normal"
                      style={{ marginTop: "0px" }}
                      onChange={(e) => setSearch(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <CloseIcon onClick={() => setSearch('')} style={{ cursor: 'pointer' }} fontSize='small' />
                        </InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid item md={8} style={{ textAlign: "right", }}>
                  </Grid>
                </Grid>
              </div>
          <Paper style={{maxHeight:`${window.innerHeight - 155}px`, overflow:'scroll'}}>
             <Table className='mui-table-format' stickyHeader>
                <CurrenciesHd createSortHandler={createSortHandler} sortInfo={sortInfo}/>
                <TableBody>
                  {(currenciesInfo || [])
                    .filter(item => item?.name?.toLowerCase().includes(search.toLowerCase()))
                    .map((item, index) => (
                      <CurrenciesList key={item?.id || index} item={item} index={index} getCurrencies={getCurrencies} />
                    ))}
                </TableBody>
             </Table>
          </Paper> </>}
        </div>
      </Paper>
    </section>
  )
}

export default CurrenciesIndex
